/* FW GHL Widget Brand — intercepts config fetch */
(function(){
  var C={chatBubbleColor:"#3898CD",headerColor:"#3898CD",buttonColor:"#3898CD",senderMessageColor:"#3898CD",avatarBorderColor:"#3898CD"};
  var o=window.fetch;
  window.fetch=function(u,opts){
    var s=typeof u==='string'?u:(u.url||u.href||'');
    if(s.indexOf('/chat-widget/public/config/')>-1){
      return o.apply(this,arguments).then(function(r){
        return r.clone().text().then(function(t){
          try{
            var p=JSON.parse(t);
            var th=p.config&&p.config.theme;
            if(typeof th==='string'){var x=JSON.parse(th);if(x.colors)for(var k in C)x.colors[k]=C[k];p.config.theme=JSON.stringify(x)}
            return new Response(JSON.stringify(p),{status:r.status,headers:r.headers})
          }catch(e){return r.clone()}
        })
      })
    }
    return o.apply(this,arguments)
  }
})();


/* Aria 2026-06-26: force compact trade hero via loaded JS asset while Shopify page template cache is stale */
(function(){
  try{
    if(!/\/pages\/trade-pricing\/?/.test(location.pathname)) return;
    if(document.getElementById('fw-trade-js-compact-hero')) return;
    var css = '.trade-page .trade-hero{min-height:0!important;height:auto!important;padding:32px 0 28px!important;display:flex!important;align-items:center!important}' +
      '.trade-page .trade-hero-inner{width:min(100% - 3rem,1200px)!important;max-width:1200px!important;grid-template-columns:minmax(0,1fr) 420px!important;gap:48px!important;align-items:center!important}' +
      '.trade-page .trade-form-card{width:420px!important;max-width:100%!important;margin:0!important}' +
      '.trade-page .trade-form-body{padding:0!important}' +
      '.trade-page .trade-hero-sub{margin-bottom:22px!important}' +
      '.trade-page .trade-hero-cta-row{margin-bottom:18px!important}' +
      '@media(max-width:1024px){.trade-page .trade-hero{padding:30px 24px 26px!important}.trade-page .trade-hero-inner{grid-template-columns:1fr!important;gap:28px!important}.trade-page .trade-form-card{width:100%!important;max-width:430px!important;margin:0 auto!important}}';
    var s=document.createElement('style'); s.id='fw-trade-js-compact-hero'; s.textContent=css; document.head.appendChild(s);
  }catch(e){}
})();

/* FW 2026-06-26: override GHL live-chat intro so it does not pretend to assign an agent. */
(function(){
  if(window.__fwGhlIntroOverrideAsset) return;
  window.__fwGhlIntroOverrideAsset = true;
  var WIDGET_ID='6a17a8f29defcaefa6e0efc9';
  var GREETING='Hi there! How can I help you today at Furniture World? 😊';
  var BAD='Give us a minute to assign you the best person to help you out.';
  function fix(data){
    try{
      var obj=data;
      if(typeof obj==='string') obj=JSON.parse(obj);
      var cfg=obj&&(obj.config||obj.data||obj.widget||obj);
      if(cfg&&typeof cfg==='object'){
        cfg['live-chat-intro-msg']=GREETING;
        cfg['prompt-msg']=GREETING;
        cfg['all-in-one-initial-msg']='Choose a chat option to get started.';
        cfg['sub-heading']='Ask us anything about Furniture World products, orders, finance, delivery, or custom NZ-made furniture.';
      }
      return obj;
    }catch(e){return data;}
  }
  var prevFetch=window.fetch;
  if(prevFetch){
    window.fetch=function(input,init){
      var url=(typeof input==='string')?input:((input&&input.url)||'');
      return prevFetch.apply(this,arguments).then(function(resp){
        if(url.indexOf('/chat-widget/public/config/'+WIDGET_ID)!==-1){
          return resp.clone().json().then(function(data){
            return new Response(JSON.stringify(fix(data)),{status:resp.status,statusText:resp.statusText,headers:resp.headers});
          }).catch(function(){return resp;});
        }
        return resp;
      });
    };
  }
  function clean(){
    var cw=document.querySelector('chat-widget'), sr=cw&&cw.shadowRoot;
    if(!sr) return;
    sr.querySelectorAll('div,span,p,li').forEach(function(el){
      var txt=(el.textContent||'').replace(/\s+/g,' ').trim();
      if(txt.indexOf(BAD)!==-1){
        var n=el;
        for(var i=0;i<8&&n&&n!==sr;i++){
          var cls=(n.className||'')+'';
          if(/message|bubble|item|chat|conversation/i.test(cls)||n.getAttribute('role')==='listitem') break;
          n=n.parentElement;
        }
        (n&&n!==sr?n:el).style.setProperty('display','none','important');
      }
    });
  }
  setInterval(clean,500);
})();

;(function(){
  if(window.__fwGhlProductQueryFallback20260626) return;
  window.__fwGhlProductQueryFallback20260626 = true;
  var GREETING = 'Hi there! How can I help you today at Furniture World? 😊';
  var FALLBACK = 'Yes, we can help. Please send your name and phone number — our team will call you with the fastest option.';
  var PRODUCT_RE = /\b(need|looking|want|after|buy|price|have|stock|available|availability|quote|cost|show me|find)\b[\s\S]{0,80}\b(bed\s*frame|bedframe|bed|mattress|sofa|couch|lounge|recliner|dining|table|chair|chairs|headboard|base|dresser|tallboy|furniture)\b|\b(bed\s*frame|bedframe|mattress|sofa|couch|lounge|recliner|dining\s*(table|chair|chairs)?|headboard|bed\s*base|dresser|tallboy)\b/i;
  function norm(s){return (s||'').replace(/\s+/g,' ').trim();}
  function isGreeting(s){return norm(s)===GREETING;}
  function isProduct(s){s=norm(s); return s && s.length<260 && PRODUCT_RE.test(s) && !isGreeting(s);}
  function replaceText(el){
    try{
      if(el && isGreeting(el.textContent)){
        el.textContent = FALLBACK;
        el.setAttribute('data-fw-product-fallback','true');
      }
    }catch(e){}
  }
  function scan(){
    try{
      var host=document.querySelector('chat-widget');
      var sr=host&&host.shadowRoot;
      if(!sr) return;
      var els=Array.prototype.slice.call(sr.querySelectorAll('div,span,p,li,section,article'))
        .filter(function(el){var t=norm(el.textContent); return t && t.length<320;});
      var seenProduct=false, greetingCount=0;
      els.forEach(function(el){
        var t=norm(el.textContent);
        if(isProduct(t)) seenProduct=true;
        if(isGreeting(t)){
          greetingCount++;
          if(seenProduct) replaceText(el);
        }
      });
    }catch(e){}
  }
  var tries=0;
  var timer=setInterval(function(){scan(); if(++tries>120) clearInterval(timer);},500);
  document.addEventListener('click',function(){setTimeout(scan,250);},true);
  document.addEventListener('keyup',function(){setTimeout(scan,350);},true);
  try{new MutationObserver(scan).observe(document.documentElement,{subtree:true,childList:true,characterData:true});}catch(e){}
})();

;(function(){
  if(window.__fwGhlMiddleAiButton20260626) return;
  window.__fwGhlMiddleAiButton20260626 = true;
  var OLD='Live Chat with Our Team';
  var NEW='Live Chat';
  var AI_NOTE='Ask our AI assistant about products, prices, delivery, finance, or store help. If needed, our team can still follow up.';
  function txt(el){return (el&&(el.innerText||el.textContent)||'').replace(/\s+/g,' ').trim();}
  function replaceOwnText(el, from, to){
    try{
      Array.prototype.slice.call(el.childNodes||[]).forEach(function(n){
        if(n.nodeType===3 && n.nodeValue.indexOf(from)!==-1) n.nodeValue=n.nodeValue.replace(from,to);
      });
      if(txt(el)===from) el.textContent=to;
    }catch(e){}
  }
  function patch(){
    try{
      var host=document.querySelector('chat-widget'), sr=host&&host.shadowRoot;
      if(!sr) return;
      var candidates=Array.prototype.slice.call(sr.querySelectorAll('button,div,span,p'));
      candidates.forEach(function(el){
        var t=txt(el);
        if(t===OLD || t.indexOf(OLD)>-1){
          replaceOwnText(el, OLD, NEW);
          el.setAttribute('data-fw-ai-chat-button','true');
          var box=el.closest && (el.closest('button')||el.closest('[role="button"]')||el.closest('div'));
          if(box) box.setAttribute('aria-label',NEW);
        }
      });
      // If the live-chat channel opens to a plain intro with no input/buttons yet, clarify this is the AI route.
      var hasAiButton=candidates.some(function(e){return txt(e).indexOf(NEW)>-1;});
      var hasInput=sr.querySelector('textarea,input,[contenteditable="true"]');
      var hasOptions=candidates.some(function(e){var t=txt(e);return t==='Email Us'||t===NEW||t.indexOf('Call Us')===0;});
      if(false && !hasOptions && !hasInput){
        candidates.forEach(function(el){
          var t=txt(el);
          if(t==='Hi there! How can I help you today at Furniture World? 😊'){
            if(!sr.querySelector('[data-fw-ai-note="true"]')){
              var n=document.createElement('div');
              n.setAttribute('data-fw-ai-note','true');
              n.textContent=AI_NOTE;
              n.style.cssText='margin:10px 24px;padding:12px 14px;border-radius:10px;background:#F2F4F7;color:#111828;font:14px/1.35 Roboto,Arial,sans-serif;';
              el.parentNode&&el.parentNode.appendChild(n);
            }
          }
        });
      }
    }catch(e){}
  }
  var tries=0, timer=setInterval(function(){patch(); if(++tries>180) clearInterval(timer);},400);
  document.addEventListener('click',function(){setTimeout(patch,150);setTimeout(patch,800);},true);
  try{new MutationObserver(patch).observe(document.documentElement,{subtree:true,childList:true,characterData:true});}catch(e){}
})();

;(function(){
  if(window.__fwGhlForceThreeButtons20260626) return;
  window.__fwGhlForceThreeButtons20260626 = true;
  function txt(e){return (e&&(e.innerText||e.textContent)||'').replace(/\s+/g,' ').trim();}
  function mk(label,fn){var b=document.createElement('button');b.type='button';b.className='chat-selection-button fw-forced-chat-option';b.textContent=label;b.style.cssText='display:block;width:calc(100% - 48px);margin:10px 24px;padding:13px 14px;border:1px solid #D0D5DD;border-radius:10px;background:#fff;color:#111828;font:600 14px/1.2 Roboto,Arial,sans-serif;text-align:center;cursor:pointer;';b.addEventListener('click',fn,true);return b;}
  function patch(){try{var cw=document.querySelector('chat-widget'),sr=cw&&cw.shadowRoot;if(!sr)return;var texts=[].map.call(sr.querySelectorAll('button,div,span,p'),txt);var has=texts.some(function(t){return t==='Email Us'||t.indexOf('Live Chat')>-1||t.indexOf('Call Us')>-1;});var choose=texts.some(function(t){return t.indexOf('Choose a chat option')>-1||t.indexOf('Furniture World Live Support')>-1;});if(!has&&choose&&!sr.querySelector('[data-fw-forced-three-buttons="true"]')){var c=sr.querySelector('.lc_text-widget--formContainer')||sr.querySelector('.lc_text-widget--box.active')||sr.querySelector('.lc_text-widget--box')||sr.firstElementChild;if(!c)return;var w=document.createElement('div');w.setAttribute('data-fw-forced-three-buttons','true');w.style.cssText='padding:6px 0 14px;';w.appendChild(mk('Email Us',function(e){e.preventDefault();e.stopImmediatePropagation();location.href='mailto:info@furnitureworld.co.nz';}));w.appendChild(mk('Live Chat',function(e){e.preventDefault();e.stopImmediatePropagation();var m=document.createElement('div');m.textContent='Hi — ask our AI assistant about products, prices, delivery, finance, or store help. What are you looking for today?';m.style.cssText='margin:10px 24px;padding:12px 14px;border-radius:10px;background:#F2F4F7;color:#111828;font:14px/1.35 Roboto,Arial,sans-serif;';w.replaceWith(m);}));w.appendChild(mk('Call Us (09 873 6364)',function(e){e.preventDefault();e.stopImmediatePropagation();location.href='tel:+6498736364';}));c.appendChild(w);}}catch(e){}}
  var i=0,t=setInterval(function(){patch();if(++i>240)clearInterval(t);},300);
  document.addEventListener('click',function(){setTimeout(patch,100);setTimeout(patch,800);},true);
  try{new MutationObserver(patch).observe(document.documentElement,{subtree:true,childList:true,characterData:true});}catch(e){}
})();



/* FW 2026-06-27: permanent short positive handoff rule for Conversation AI/live chat.
   If AI produces a refusal/contradiction or long delivery limitation, replace it with a short yes + callback capture. */
;(function(){
  if(window.__fwGhlNoNoShortCallbackRule20260627) return;
  window.__fwGhlNoNoShortCallbackRule20260627 = true;
  var REPLY = 'Yes, we can help. Some items are available for pickup or delivery straight away. Please send your name and phone number — our team will confirm availability and the fastest option.';
  var NEG_RE = /\b(can'?t|cannot|can not|unable|not able|don'?t|do not|won'?t|not possible|unfortunately|sorry|not available|not in stock)\b/i;
  var FW_LIMIT_RE = /\b(4\s*weeks?|2\s*-\s*4\s*weeks?|4\s*-\s*6\s*weeks?|5\s*-\s*10 working days|made[- ]to[- ]order|made to order|built to order|not available for immediate pickup|available for delivery|available for pickup|ready for delivery|next[- ]day delivery|delivery tomorrow|tomorrow delivery|usually can'?t offer|confirm availability|preferred configuration)\b/i;
  function norm(s){return (s||'').replace(/\s+/g,' ').trim();}
  function isClientText(t){
    t=norm(t).toLowerCase();
    return /\b(i|we|need|want|looking|deliver|delivery|tomorrow|today|urgent|bed|mattress|sofa|table|chair)\b/.test(t) && t.length<220;
  }
  function shouldFix(t){
    t=norm(t);
    if(!t || t===REPLY || t.length<40 || t.length>1200) return false;
    if(t.indexOf('Furniture World')===-1 && !FW_LIMIT_RE.test(t) && !NEG_RE.test(t)) return false;
    return (NEG_RE.test(t) || FW_LIMIT_RE.test(t)) && (t.length>110 || /tomorrow|next[- ]day|built to order|made[- ]to[- ]order|made to order|4\s*weeks?|2\s*-\s*4\s*weeks?|immediate pickup|confirm availability|preferred configuration|5\s*-\s*10/i.test(t));
  }
  function setText(el){
    try{
      if(!el || el.getAttribute('data-fw-no-no-short-rule')==='true') return;
      el.textContent = REPLY;
      el.setAttribute('data-fw-no-no-short-rule','true');
    }catch(e){}
  }
  function scan(){
    try{
      var host=document.querySelector('chat-widget'), sr=host&&host.shadowRoot;
      if(!sr) return;
      var els=Array.prototype.slice.call(sr.querySelectorAll('div,span,p,li,section,article'));
      var hasClient=false;
      els.forEach(function(el){ if(isClientText(el.textContent)) hasClient=true; });
      if(!hasClient) return;
      els.forEach(function(el){ if(shouldFix(el.textContent)) setText(el); });
    }catch(e){}
  }
  var tries=0, timer=setInterval(function(){scan(); if(++tries>240) clearInterval(timer);},500);
  document.addEventListener('click',function(){setTimeout(scan,250);setTimeout(scan,1000);},true);
  document.addEventListener('keyup',function(){setTimeout(scan,350);setTimeout(scan,1200);},true);
  try{new MutationObserver(scan).observe(document.documentElement,{subtree:true,childList:true,characterData:true});}catch(e){}
})();

/* FW marker __fwGhlNoNoShortCallbackRule20260627 */
